import type { FaireThemeEntity } from "../../entity_types/theme";

export const elevated_everyday_layers: FaireThemeEntity = {
  token: "elevated-everyday-layers",
  type: "theme",
  name: "Elevated Everyday Layers",
  description: "Stylish hoodies and cardigans designed for a \"light maturity\" aesthetic, perfect for transitioning your inventory between seasons.",
  teaser: "This theme aligns with your frequent orders for graphic sweatshirts and cardigans, as well as your predicted store type of clothing.",
  detail: "The additional_context contains the Long Sleeve Hoodie with Zipper and the Fashion Contrast Print Cardigan, both of which provide versatile layering options.",
  bgColor: "#D5E8D4",
  tileBgColor: "#6b5430",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_ax42ytu9uz",
    "p_yqpd4fnyac",
    "p_azjnajjgcg",
    "p_r4qt2uprvh",
    "p_enmra4pcwt",
    "p_mt4cay9hf5",
    "p_cuh9zfbh6q",
    "p_bank8vs3zr",
    "p_trpp5ad4tc",
    "p_px39suuz5c",
    "p_9ef2yrh93p",
    "p_4w7a6pw4dz",
    "p_9qm53bpqrn",
    "p_nsf4r3ja7c",
    "p_wp5952ug5n",
    "p_kdspx6vu84",
    "p_8q2nsddjxb",
    "p_qgrg4tcvgg",
    "p_b8bigpa1gq",
    "p_gfvyvnv75m",
    "p_6bfhf9tfzt",
    "p_4956p8ks8z",
    "p_uswwmaczta",
    "p_ghqv6tw2mz",
    "p_j43fre32cm",
    "p_8mzk5vf287",
    "p_g3g8677jhp",
    "p_mtgvutwpdj",
    "p_dmn22zbbrg",
    "p_8m8mv8vgyv",
    "p_p34te2qydc",
    "p_u7bfnkftvh",
    "p_67f3hdsyyv",
    "p_nmvgqas665",
    "p_93u9fqx97z",
    "p_eq64uy67k2",
    "p_ban7fks9un",
    "p_vusrvvreyk",
    "p_pnv3n39s26",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
